var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKusamaInline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M37.57,71.5l6.85.1L12,88.49l2.68.4-4.49,3.49s1.77.08,3.48,0a14,14,0,0,0,4.77-1.28l-.47,1.15s16.15-5.78,21.15-7.42c18.65-6.11,26.56-4.62,26.56-4.62l-4.17,1.45a31.75,31.75,0,0,0,5.77.53c1.24,0,1.63.84,1.74,1.73a8,8,0,0,0,2.94,4.67,70,70,0,0,1,5.75,4.85c.4.5.57,1-.23,1.6a11.26,11.26,0,0,0-1.66,1.69A34.34,34.34,0,0,1,82.35,96a47.28,47.28,0,0,1,6.22.6,8.74,8.74,0,0,0-2.83-1.9c-1.86-.86-10.2-4.79-10-12.53.15-6.09,9.81-8.27,17.58-13,8.58-5.22,9.51-12.47,11.37-17.52,2.22-6,5.09-8.88,8.22-10.14,1.66-.68,5-1.87,5-1.87s-6-5.81-9.71-7.51a10.93,10.93,0,0,0-9.57.53c-3.86,2.06-8.28,6.19-11,8.88-1.89,1.89-5.8,2.44-10.47,5C67.51,51.84,37.57,71.5,37.57,71.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKusamaInline);
export default __webpack_public_path__ + "static/media/kusama_inline.849721521463251c05c3bc88c4bfb234.svg";
export { ForwardRef as ReactComponent };